// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25T-5","top":"styles_top__1Zi0K"};